import * as React from "react";

function SvgAmbassador(props, ref) {
  return (
    <svg
      id="Ambassador_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 62 86.8"
      xmlSpace="preserve"
      enableBackground="new 0 0 62 86.8"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Ambassador_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#383838}.Ambassador_svg__st0,.Ambassador_svg__st1{display:none}.Ambassador_svg__st2{display:inline}.Ambassador_svg__st12,.Ambassador_svg__st13,.Ambassador_svg__st4{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.Ambassador_svg__st12,.Ambassador_svg__st13{fill:#05a6cc}.Ambassador_svg__st13{fill:#383838}.Ambassador_svg__st19,.Ambassador_svg__st24,.Ambassador_svg__st25{fill-rule:evenodd;clip-rule:evenodd}.Ambassador_svg__st24{display:inline;fill:#fff}.Ambassador_svg__st25{fill:#e8e8e8}"
        }
      </style>
      <g id="Ambassador_svg__Page-1_00000129197211823676212170000012130557619150069171_">
        <g id="Ambassador_svg__Branding" transform="translate(-30 -131)">
          <g id="Ambassador_svg__Color-logo" transform="translate(30 131)">
            <path
              id="Ambassador_svg__Fill-1"
              className="Ambassador_svg__st0"
              d="M93.7 30.5L82.6 58.1h22.2L93.7 30.5zM89.8 23h8.4l23.6 55.7H113l-5.7-14.1H80l-5.7 14.1H66L89.8 23z"
            />
            <g id="Ambassador_svg__Group-38" transform="translate(0 .168)">
              <path
                id="Ambassador_svg__Fill-2"
                className="Ambassador_svg__st0"
                d="M124.3 37.9h7v5.9h.2c2.9-4.7 6.9-6.9 12.9-6.9 4.7 0 9.4 2.4 11.6 7.9 2.8-5.8 8.9-7.9 12.6-7.9 10.4 0 14.1 6.7 14.1 15.6v26.1h-7.5V54.3c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V54.3c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V37.9z"
              />
              <path
                id="Ambassador_svg__Fill-4"
                className="Ambassador_svg__st0"
                d="M205.9 43c-8.1 0-12.1 7.7-12.1 15.3 0 6.8 3.5 15.2 12 15.2 8.1 0 11.4-9 11.3-15.4.1-7.4-3.1-15.1-11.2-15.1zm-19.6-24.3h7.5v24.8h.2c2.3-3.8 6.4-6.5 13.5-6.5 11.8 0 17.6 9.7 17.6 20.6 0 11.2-5.2 22-17.5 22-7.3 0-11.9-3.7-13.9-6.7h-.2v5.8h-7.2v-60z"
              />
              <g
                id="Ambassador_svg__Group-8"
                transform="translate(226.706 37.085)"
                className="Ambassador_svg__st1"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.2}
                    width={34.7}
                    height={42.6}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.2}
                  width={34.7}
                  height={42.6}
                  id="Ambassador_svg__mask-2_00000176036579594043205760000005569281611849272725_"
                  className="Ambassador_svg__st2"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter)">
                    <path
                      id="Ambassador_svg__path-1_00000161617525048399302830000015874237568730205324_"
                      className="Ambassador_svg__st4"
                      d="M0 42.4h34.7V-.2H0z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-6"
                  d="M26.9 22.1c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.7-14.1 7.9 0 4.3 4.2 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.6zM4.6 3.6C8.4 1.4 12.9-.2 18-.2c11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2C6.1 42.4 0 38.6 0 29.8c0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2-.1-8.7 1.5-11.8 4l-.4-6.4z"
                  display="inline"
                  mask="url(#Ambassador_svg__mask-2_00000176036579594043205760000005569281611849272725_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#383838"
                />
              </g>
              <g
                id="Ambassador_svg__Group-11"
                transform="translate(264.723 37.085)"
                className="Ambassador_svg__st1"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000163767302644556640670000005137616147556259222_"
                    filterUnits="userSpaceOnUse"
                    x={0.1}
                    y={-0.2}
                    width={25.6}
                    height={42.6}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0.1}
                  y={-0.2}
                  width={25.6}
                  height={42.6}
                  id="Ambassador_svg__mask-4_00000017506283284217338820000017368785247898412709_"
                  className="Ambassador_svg__st2"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000163767302644556640670000005137616147556259222_)">
                    <path
                      id="Ambassador_svg__path-3_00000013156255863574790840000011892955249481351572_"
                      className="Ambassador_svg__st4"
                      d="M.1 42.4h25.6V-.2H.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-9"
                  d="M.7 33.5c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8C17.7 23.2.1 23.8.1 12.4.1 3.9 6.4-.1 14.5-.1c3.5 0 6.4.7 9.3 1.6L23.2 8c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
                  display="inline"
                  mask="url(#Ambassador_svg__mask-4_00000017506283284217338820000017368785247898412709_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#383838"
                />
              </g>
              <g
                id="Ambassador_svg__Group-14"
                transform="translate(292.478 37.085)"
                className="Ambassador_svg__st1"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000054979784952596991360000006088470366178506174_"
                    filterUnits="userSpaceOnUse"
                    x={0.1}
                    y={-0.2}
                    width={25.6}
                    height={42.6}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0.1}
                  y={-0.2}
                  width={25.6}
                  height={42.6}
                  id="Ambassador_svg__mask-6_00000134210045443597207520000002056536907260255403_"
                  className="Ambassador_svg__st2"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000054979784952596991360000006088470366178506174_)">
                    <path
                      id="Ambassador_svg__path-5_00000145056590129116328300000011540589178371010695_"
                      className="Ambassador_svg__st4"
                      d="M.1 42.4h25.6V-.2H.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-12"
                  d="M.7 33.5c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8C17.7 23.2.1 23.8.1 12.4.1 3.9 6.4-.1 14.5-.1c3.5 0 6.4.7 9.3 1.6L23.1 8c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.5-6.8z"
                  display="inline"
                  mask="url(#Ambassador_svg__mask-6_00000134210045443597207520000002056536907260255403_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#383838"
                />
              </g>
              <g
                id="Ambassador_svg__Group-17"
                transform="translate(320.233 37.085)"
                className="Ambassador_svg__st1"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000134939376964649885150000003692837807151751322_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.2}
                    width={34.7}
                    height={42.6}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.2}
                  width={34.7}
                  height={42.6}
                  id="Ambassador_svg__mask-8_00000003823055637815718750000012871506435796123291_"
                  className="Ambassador_svg__st2"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000134939376964649885150000003692837807151751322_)">
                    <path
                      id="Ambassador_svg__path-7_00000097468549426855064340000010416964408834661555_"
                      className="Ambassador_svg__st4"
                      d="M0 42.4h34.7V-.2H0z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-15"
                  d="M26.9 22.1c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.7-14.1 7.9 0 4.3 4.1 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.6zM4.6 3.6C8.4 1.4 12.9-.2 18-.2c11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2C6.2 42.4 0 38.6 0 29.8c0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2-.1-8.7 1.5-11.8 4l-.4-6.4z"
                  display="inline"
                  mask="url(#Ambassador_svg__mask-8_00000003823055637815718750000012871506435796123291_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#383838"
                />
              </g>
              <path
                id="Ambassador_svg__Fill-18"
                className="Ambassador_svg__st0"
                d="M376.7 73.5c8.5 0 12-8.4 12-15.2 0-7.6-3.9-15.3-12.1-15.3-8.1 0-11.3 7.7-11.2 15.1-.1 6.3 3.3 15.4 11.3 15.4zm12.3-.7h-.2c-2 3-6.6 6.7-13.9 6.7-12.3 0-17.5-10.9-17.5-22 0-10.9 5.8-20.6 17.6-20.6 7.1 0 11.2 2.8 13.5 6.5h.2V18.7h7.5v59.9H389v-5.8z"
              />
              <path
                id="Ambassador_svg__Fill-20"
                className="Ambassador_svg__st0"
                d="M419.7 73.5c8.8 0 12.7-8 12.7-15.2 0-7.7-4.7-15.2-12.7-15.2-8.1 0-12.8 7.5-12.8 15.2 0 7.2 3.9 15.2 12.8 15.2m0-36.6c12.4 0 20.7 8.9 20.7 21.3 0 11.7-8.5 21.3-20.7 21.3-12.3 0-20.8-9.7-20.8-21.3 0-12.4 8.4-21.3 20.8-21.3"
              />
              <path
                id="Ambassador_svg__Fill-22"
                className="Ambassador_svg__st0"
                d="M444 37.9h7v6.3h.2c2-4.2 6.3-7.3 10.6-7.3 2.2 0 3.4.2 5 .6v6.7c-1.4-.6-2.9-.7-4.2-.7-6.7 0-11.1 6.4-11.1 16.6v18.5H444V37.9z"
              />
              <path
                id="Ambassador_svg__Fill-24"
                className="Ambassador_svg__st12"
                d="M55.5 43.4c0 .5-.1 1-.4 1.4l-.1.2-6.3 9.2-1.1 1.5-.5.8-2.8 4-.5.7-3.2 4.8c0 .1-.1.2-.2.2-.3.3-.6.5-1.1.6H39c-.5 0-.9-.2-1.2-.5l-.1-.1-.4-.4c-2-2.1-5.1-5.4-8.2-8.7-.5-.6-1-1.1-1.5-1.7l-.3-.3c-.2-.2-.3-.5-.5-.7-1.4-1.6-2.8-3-3.8-4.3-.7-.7-1.2-1.3-1.7-1.8-.2-.3-.5-.5-.7-.8-.1-.1-.1-.2-.2-.3-.2-.4-.4-.8-.4-1.2 0-.3.1-.6.2-.9.1-.1.1-.2.2-.4s.2-.4.4-.6c.1-.1.1-.2.2-.3 0-.1.1-.1.1-.2.2-.3.5-.7.7-1 .1-.1.2-.3.3-.4.8-1.1 1.6-2.2 2.5-3.3.7-.9 1.3-1.7 2-2.6.2-.2.3-.5.5-.7 1-1.5 1.9-3.2 2.5-5.2 0-.2.1-.3.1-.5v-.3c.8-2.6 2.3-5.4 3.5-8.1 1.2-2 2.2-3.9 3.2-5.5.3-.4.6-.9.8-1.3.3-.4.5-.8.8-1.2v-.1l.6-.9c.1-.1.2-.3.3-.4 0-.1.1-.1.1-.2.1-.1.2-.3.3-.4.2-.2.3-.4.4-.6l1.2-.3c.1 0 .2-.1.4-.1.1 0 .1-.1.2-.1l2.3 5.9 11.3 25.8.1.1c.3.4.3.8.3 1.2"
              />
              <path
                id="Ambassador_svg__Fill-26"
                className="Ambassador_svg__st13"
                d="M55.4 76.9c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.2 2-2.1 4.8-2.5l-1.7-13.1.5-.7 2.8-4 .5-.8 2.4 18.5c3 .3 5.3 1.3 5.3 2.6"
              />
              <path
                id="Ambassador_svg__Fill-28"
                className="Ambassador_svg__st13"
                d="M41.6 10.4c-.1 0-.1 0-.2.1-.1 0-.2.1-.4.1l-1.2.3c-.1.2-.3.4-.4.6-.1.1-.2.3-.3.4 0 .1-.1.1-.1.2-.1.1-.2.3-.3.4l-.6.9v.1c-.3.4-.5.8-.8 1.2.4-.7.6-1.5.6-2.4l-.2-1.4c-.4-.1-.8-.2-1-.3-.4-.2-.6-.4-.6-.7 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.3-2.4.1-1.5.2-2.8c0-.4.4-.8.9-.8.3 0 .6.2.8.4l.1.2 1 2.5 1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.3.5.6.6.9.1.5-.5 1-1.4 1.4"
              />
              <path
                id="Ambassador_svg__Fill-30"
                className="Ambassador_svg__st13"
                d="M35.2 76.8c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.1 2-2.1 4.7-2.5l-1.7-13 .6-.8 1.9-2.7c.4.4.8.9 1.2 1.3v.1c.1 0 .1.1.2.1l.3.3c.1.1.2.3.3.5l.1.4L30 74.3c3 .2 5.2 1.3 5.2 2.5"
              />
              <g id="Ambassador_svg__Group-34" transform="translate(15.86)">
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000029724927713468941860000017249300721790336170_"
                    filterUnits="userSpaceOnUse"
                    x={0.1}
                    y={-0.2}
                    width={6.8}
                    height={15.2}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0.1}
                  y={-0.2}
                  width={6.8}
                  height={15.2}
                  id="Ambassador_svg__mask-10_00000102520342741840700810000005600465062620133263_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000029724927713468941860000017249300721790336170_)">
                    <path
                      id="Ambassador_svg__path-9_00000169534684075289110750000011966498810018055079_"
                      className="Ambassador_svg__st4"
                      d="M7-.2H.1V15H7z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-32"
                  d="M5.6 10.4c-.1 0-.2.1-.2.1-.1 0-.2.1-.4.1v-.1.1l-1.2.3c-.3.4-.7 1-1.1 1.6-.1.1-.1.2-.2.2-.1.1-.2.3-.3.4-.1.1 0 .2-.3.3-.2.5-.6 1-.9 1.5.5-.9.8-2 .8-3.1l-.1-1C.8 10.6.1 10.3.1 9.7c0-.2 0-.3.1-.5.1 0 .3-.2.4-.3l.1-1.6.3-2.5.1-1.5.2-2.7c0-.5.4-.8.9-.8.4 0 .7.2.8.6L4 3l1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.4.6.7.1.5-.4 1.1-1.3 1.5"
                  mask="url(#Ambassador_svg__mask-10_00000102520342741840700810000005600465062620133263_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#383838"
                />
              </g>
              <g id="Ambassador_svg__Group-37" transform="translate(0 10.496)">
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000140015369281475402130000000690064408141957813_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.1}
                    width={27.8}
                    height={56.5}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.1}
                  width={27.8}
                  height={56.5}
                  id="Ambassador_svg__mask-12_00000122691942617992929190000012319466906663644094_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000140015369281475402130000000690064408141957813_)">
                    <path
                      id="Ambassador_svg__path-11_00000080905245405481662690000010896652413517440131_"
                      className="Ambassador_svg__st4"
                      d="M0-.1v56.4h27.8V-.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-35"
                  d="M27.8 15.4v.4c-.4 2.5-1.2 4.8-2.2 6.6-.2.5-.7 1.3-1.4 2.3-.8 1.1-1.8 2.4-2.8 3.7-.2.2-.3.4-.5.6-.1.1-.1.2-.2.3-1.4 1.7-2.7 3.4-3.5 4.7l-.3.6c-.1.3-.2.7-.2 1.1 0 .6.2 1.1.5 1.6l.3.3c1.1 1.4 3.1 3.6 5.3 6 .3.3.5.6.8.9.8.9 1.7 1.9 2.6 2.8l-2 2.7-.6.8-3.2 4.7-.1.1c-.3.4-.8.7-1.3.7h-.1c-.5 0-.9-.2-1.2-.5l-.1-.1c-3.9-4.1-14-14.8-17-18.5-.4-.5-.6-1.1-.6-1.7 0-.5.1-.9.3-1.3 1.2-2.1 3.7-5.3 5.8-7.9.6-.7 1.1-1.5 1.5-2.1.6-1.1 1.2-2.2 1.6-3.5.1-.4.3-.9.4-1.4.7-2.4 1.9-4.9 3.1-7.4 1.2-2.3 2.5-4.6 3.7-6.5.2-.2.3-.5.4-.7.5-.7.9-1.3 1.1-1.7.2-.1.2-.2.3-.3.1-.2.2-.3.3-.4.1-.1.1-.2.2-.2.4-.6.8-1.1 1.1-1.6L21 .2c0-.1.1-.2.3-.2.1 0 .2-.1.2-.1l.9 2.3L23.5 5l4.1 9.4.2.4v.6"
                  mask="url(#Ambassador_svg__mask-12_00000122691942617992929190000012319466906663644094_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#dc1f26"
                />
              </g>
            </g>
          </g>
          <g
            id="Ambassador_svg__black-logo"
            transform="translate(30 276)"
            className="Ambassador_svg__st1"
          >
            <path
              id="Ambassador_svg__Fill-1_00000101820200558459315710000007150438767690472861_"
              d="M93.7 30.2L82.6 57.8h22.2L93.7 30.2zm-3.9-7.5h8.4l23.6 55.7H113l-5.7-14.1H80l-5.7 14.1H66l23.8-55.7z"
              display="inline"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <g
              id="Ambassador_svg__Group-34_00000025421410654417002140000000997464683305840555_"
              transform="translate(0 .16)"
              className="Ambassador_svg__st2"
            >
              <path
                id="Ambassador_svg__Fill-2_00000181082135632388628080000004737128465092250273_"
                className="Ambassador_svg__st19"
                d="M124.3 37.5h7v5.9h.2c2.9-4.7 6.9-6.9 12.9-6.9 4.7 0 9.4 2.4 11.6 7.9 2.8-5.8 8.9-7.9 12.6-7.9 10.4 0 14.1 6.7 14.1 15.6v26.1h-7.5V54c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V54c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V37.5z"
              />
              <path
                id="Ambassador_svg__Fill-4_00000036951223182735155680000015225864213673467794_"
                className="Ambassador_svg__st19"
                d="M205.9 42.6c-8.1 0-12.1 7.7-12.1 15.3 0 6.8 3.5 15.2 12 15.2 8.1 0 11.4-9 11.3-15.4.1-7.3-3.1-15.1-11.2-15.1zm-19.6-24.2h7.5v24.8h.2c2.3-3.8 6.4-6.5 13.5-6.5 11.8 0 17.6 9.7 17.6 20.6 0 11.2-5.2 22-17.5 22-7.3 0-11.9-3.7-13.9-6.7h-.2v5.8h-7.2v-60z"
              />
              <path
                id="Ambassador_svg__Fill-6_00000147941460319118578100000010736522209057318833_"
                className="Ambassador_svg__st19"
                d="M253.6 58.9c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.2 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.5zm-22.3-18.5c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7V73h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.5z"
              />
              <path
                id="Ambassador_svg__Fill-8"
                className="Ambassador_svg__st19"
                d="M265.5 70.3c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6l-.6 6.5c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-10"
                className="Ambassador_svg__st19"
                d="M293.2 70.3c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6l-.6 6.5c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-12_00000014633480565656460260000014646288085963561109_"
                className="Ambassador_svg__st19"
                d="M347.1 58.9c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.1 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.5zm-22.2-18.5c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7V73h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.5z"
              />
              <path
                id="Ambassador_svg__Fill-14"
                className="Ambassador_svg__st19"
                d="M376.7 73.1c8.5 0 12-8.4 12-15.2 0-7.6-3.9-15.3-12.1-15.3-8.1 0-11.3 7.7-11.2 15.1-.1 6.4 3.3 15.4 11.3 15.4zm12.3-.6h-.2c-2 3-6.6 6.7-13.9 6.7-12.3 0-17.5-10.9-17.5-22 0-10.9 5.8-20.6 17.6-20.6 7.1 0 11.2 2.8 13.5 6.5h.2V18.4h7.5v59.9H389v-5.8z"
              />
              <path
                id="Ambassador_svg__Fill-16"
                className="Ambassador_svg__st19"
                d="M419.7 73.1c8.8 0 12.7-8 12.7-15.2 0-7.7-4.7-15.2-12.7-15.2-8.1 0-12.8 7.5-12.8 15.2 0 7.3 3.9 15.2 12.8 15.2m0-36.5c12.4 0 20.7 8.9 20.7 21.3 0 11.7-8.5 21.3-20.7 21.3-12.3 0-20.8-9.7-20.8-21.3 0-12.4 8.4-21.3 20.8-21.3"
              />
              <path
                id="Ambassador_svg__Fill-18_00000047778472126066184600000012390209336430034876_"
                className="Ambassador_svg__st19"
                d="M444 37.5h7v6.3h.2c2-4.2 6.3-7.3 10.6-7.3 2.2 0 3.4.2 5 .6v6.7c-1.4-.6-2.9-.7-4.2-.7-6.7 0-11.1 6.4-11.1 16.6v18.5H444V37.5z"
              />
              <path
                id="Ambassador_svg__Fill-20_00000006694651009329614550000001007248835637912746_"
                className="Ambassador_svg__st19"
                d="M55.5 43.4c0 .5-.1 1-.4 1.4l-.1.2-6.3 9.2-1.1 1.5-.5.8-2.8 4-.5.7-3.2 4.8c0 .1-.1.2-.2.2-.3.3-.6.5-1.1.6H39c-.5 0-.9-.2-1.2-.5l-.1-.1-.4-.4c-2-2.1-5.1-5.4-8.2-8.7-.5-.6-1-1.1-1.5-1.7l-.3-.3c-.2-.2-.3-.5-.5-.7-1.4-1.6-2.8-3-3.8-4.3-.7-.7-1.2-1.3-1.7-1.8-.2-.3-.5-.5-.7-.8-.1-.1-.1-.2-.2-.3-.2-.4-.4-.8-.4-1.2 0-.3.1-.6.2-.9.1-.1.1-.2.2-.4s.2-.4.4-.6c.1-.1.1-.2.2-.3 0-.1.1-.1.1-.2.2-.3.5-.7.7-1 .1-.1.2-.3.3-.4.8-1.1 1.6-2.2 2.5-3.3.7-.9 1.3-1.7 2-2.6.2-.2.3-.5.5-.7 1-1.5 1.9-3.2 2.5-5.2 0-.2.1-.3.1-.5v-.3c.8-2.6 2.3-5.4 3.5-8.1 1.2-2 2.2-3.9 3.2-5.5.3-.4.6-.9.8-1.3.3-.4.5-.8.8-1.2v-.1l.6-.9c.1-.1.2-.3.3-.4 0-.1.1-.1.1-.2.1-.1.2-.3.3-.4.2-.2.3-.4.4-.6l1.2-.3c.1 0 .2-.1.4-.1.1 0 .1-.1.2-.1l2.3 5.9 11.3 25.8.1.1c.3.4.3.8.3 1.2"
              />
              <path
                id="Ambassador_svg__Fill-22_00000112605409499957919150000013874514939146056088_"
                className="Ambassador_svg__st19"
                d="M55.4 76.9c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.2 2-2.1 4.8-2.5l-1.7-13.1.5-.7 2.8-4 .5-.8 2.4 18.5c3 .3 5.3 1.3 5.3 2.6"
              />
              <g id="Ambassador_svg__Group-26" transform="translate(36.152)">
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000176021155499919723620000016159459932440619932_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.2}
                    width={6.8}
                    height={14.9}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.2}
                  width={6.8}
                  height={14.9}
                  id="Ambassador_svg__mask-14_00000040562635064474968800000008910798499050573216_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000176021155499919723620000016159459932440619932_)">
                    <path
                      id="Ambassador_svg__path-13_00000094587047431900651160000008569829624511349951_"
                      className="Ambassador_svg__st4"
                      d="M6.8-.2H0v14.9h6.8z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-24_00000001638413654526466250000004452828538117356672_"
                  d="M5.5 10.4c-.1 0-.1 0-.2.1-.1 0-.2.1-.4.1l-1.2.3c-.1.2-.3.4-.4.6-.1.2-.2.3-.3.5 0 0 0 .1-.1.1-.1.1-.2.3-.3.4l-.6.9v.1c-.3.4-.5.8-.8 1.2.4-.7.6-1.5.6-2.4l-.2-1.4c-.4-.1-.8-.2-1-.3-.3-.2-.5-.4-.6-.7 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.5.2-2.8c0-.4.4-.8.9-.8.3 0 .6.2.8.4l.1.3L4 3l1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.5.5.8.1.5-.4 1-1.3 1.4"
                  mask="url(#Ambassador_svg__mask-14_00000040562635064474968800000008910798499050573216_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                />
              </g>
              <path
                id="Ambassador_svg__Fill-27"
                className="Ambassador_svg__st19"
                d="M35.2 76.8c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.1 2-2.1 4.7-2.5l-1.7-13 .6-.8 1.9-2.7c.4.4.8.9 1.2 1.3v.1c.1 0 .1.1.2.1l.3.3c.1.1.2.3.3.5l.1.4L30 74.3c3 .2 5.2 1.3 5.2 2.5"
              />
              <path
                id="Ambassador_svg__Fill-29"
                className="Ambassador_svg__st19"
                d="M21.5 10.4c-.1 0-.2.1-.2.1-.1 0-.2.1-.4.1v-.1.1l-1.2.3c-.3.4-.7 1-1.1 1.6-.1.1-.1.2-.2.2-.1.1-.2.3-.3.4-.1.1 0 .2-.3.3-.2.5-.6 1-.9 1.5.5-.9.8-2 .8-3.1l-.1-1c-.9-.2-1.6-.5-1.6-1.1 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.3.2-2.6c0-.5.4-.9.9-.9.4 0 .7.2.8.5l1 2.6 1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.4.6.7.1.5-.4 1.1-1.3 1.5"
              />
              <g id="Ambassador_svg__Group-33" transform="translate(0 10.496)">
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000168118175278465692630000011666878706202114987_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.1}
                    width={27.8}
                    height={56.5}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.1}
                  width={27.8}
                  height={56.5}
                  id="Ambassador_svg__mask-16_00000180356655163391689550000005010822913538865329_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000168118175278465692630000011666878706202114987_)">
                    <path
                      id="Ambassador_svg__path-15_00000062890229917723237360000015814246216242392765_"
                      className="Ambassador_svg__st4"
                      d="M0-.1v56.4h27.8V-.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-31"
                  d="M27.8 15.4v.4c-.4 2.5-1.2 4.8-2.2 6.6-.2.5-.7 1.3-1.4 2.3-.8 1.1-1.8 2.4-2.8 3.7-.2.2-.3.4-.5.6-.1.1-.1.2-.2.3-1.4 1.7-2.7 3.4-3.5 4.7l-.3.6c-.1.3-.2.7-.2 1.1 0 .6.2 1.1.5 1.6l.3.3c1.1 1.4 3.1 3.6 5.3 6 .3.3.5.6.8.9.8.9 1.7 1.9 2.6 2.8l-2 2.7-.6.8-3.2 4.7-.1.1c-.3.4-.8.7-1.3.7h-.1c-.5 0-.9-.2-1.2-.5l-.1-.1c-3.9-4.1-14-14.8-17-18.5-.4-.5-.6-1.1-.6-1.7 0-.5.1-.9.3-1.3 1.2-2.1 3.7-5.3 5.8-7.9.6-.7 1.1-1.5 1.5-2.1.6-1.1 1.2-2.2 1.6-3.5.1-.4.3-.9.4-1.4.7-2.4 1.9-4.9 3.1-7.4 1.2-2.3 2.5-4.6 3.7-6.5.2-.2.3-.5.4-.7.5-.7.9-1.3 1.1-1.7.2-.1.2-.2.3-.3.1-.2.2-.3.3-.4.1-.1.1-.2.2-.2.4-.6.8-1.1 1.1-1.6L21 .2c0-.1.1-.2.3-.2.1 0 .2-.1.2-.1l.9 2.3L23.5 5l4.1 9.4.2.4v.6"
                  mask="url(#Ambassador_svg__mask-16_00000180356655163391689550000005010822913538865329_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                />
              </g>
            </g>
          </g>
          <g
            id="Ambassador_svg__light-on-dark-logo"
            transform="translate(30 451)"
            className="Ambassador_svg__st1"
          >
            <path
              id="Ambassador_svg__Fill-1_00000125598641113090596310000010602573240963022264_"
              className="Ambassador_svg__st24"
              d="M93.7 30.4L82.6 58h22.2L93.7 30.4zm-3.9-7.5h8.4l23.6 55.7H113l-5.7-14.1H80l-5.7 14.1H66l23.8-55.7z"
            />
            <g
              id="Ambassador_svg__Group-34_00000152254777130555393600000014324122509215152016_"
              transform="translate(0 .16)"
              className="Ambassador_svg__st2"
            >
              <path
                id="Ambassador_svg__Fill-2_00000016059447713735058280000014583301253198374789_"
                className="Ambassador_svg__st4"
                d="M124.3 37.7h7v5.9h.2c2.9-4.7 6.9-6.9 12.9-6.9 4.7 0 9.4 2.4 11.6 7.9 2.8-5.8 8.9-7.9 12.6-7.9 10.4 0 14.1 6.7 14.1 15.6v26.1h-7.5V54.2c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V54.2c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V37.7z"
              />
              <path
                id="Ambassador_svg__Fill-4_00000115477380612077486170000011493400569561330564_"
                className="Ambassador_svg__st4"
                d="M205.9 42.8c-8.1 0-12.1 7.7-12.1 15.3 0 6.8 3.5 15.2 12 15.2 8.1 0 11.4-9 11.3-15.4.1-7.3-3.1-15.1-11.2-15.1zm-19.6-24.2h7.5v24.8h.2c2.3-3.8 6.4-6.5 13.5-6.5 11.8 0 17.6 9.7 17.6 20.6 0 11.2-5.2 22-17.5 22-7.3 0-11.9-3.7-13.9-6.7h-.2v5.8h-7.2v-60z"
              />
              <path
                id="Ambassador_svg__Fill-6_00000127016139028311815750000014936711122784684928_"
                className="Ambassador_svg__st4"
                d="M253.6 59c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.2 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7V59zm-22.3-18.4c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.4z"
              />
              <path
                id="Ambassador_svg__Fill-8_00000102545346068760339130000008394607133091305905_"
                className="Ambassador_svg__st4"
                d="M265.5 70.5c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6L288 45c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-10_00000027596802788224828830000010212064364774984614_"
                className="Ambassador_svg__st4"
                d="M293.2 70.5c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6l-.6 6.5c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-12_00000106115484158911481440000016165253833851681428_"
                className="Ambassador_svg__st4"
                d="M347.1 59c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.1 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7V59zm-22.2-18.4c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.4z"
              />
              <path
                id="Ambassador_svg__Fill-14_00000089534025312749861780000016880370719252206734_"
                className="Ambassador_svg__st4"
                d="M376.7 73.3c8.5 0 12-8.4 12-15.2 0-7.6-3.9-15.3-12.1-15.3-8.1 0-11.3 7.7-11.2 15.1-.1 6.4 3.3 15.4 11.3 15.4zm12.3-.6h-.2c-2 3-6.6 6.7-13.9 6.7-12.3 0-17.5-10.9-17.5-22 0-10.9 5.8-20.6 17.6-20.6 7.1 0 11.2 2.8 13.5 6.5h.2V18.6h7.5v59.9H389v-5.8z"
              />
              <path
                id="Ambassador_svg__Fill-16_00000100367334826361026230000001201083753127512740_"
                className="Ambassador_svg__st4"
                d="M419.7 73.3c8.8 0 12.7-8 12.7-15.3 0-7.7-4.7-15.2-12.7-15.2-8.1 0-12.8 7.5-12.8 15.2 0 7.4 3.9 15.3 12.8 15.3m0-36.5c12.4 0 20.7 8.9 20.7 21.3 0 11.7-8.5 21.3-20.7 21.3-12.3 0-20.8-9.7-20.8-21.3 0-12.4 8.4-21.3 20.8-21.3"
              />
              <path
                id="Ambassador_svg__Fill-18_00000145749259081170454180000011443612004696545962_"
                className="Ambassador_svg__st4"
                d="M444 37.7h7V44h.2c2-4.2 6.3-7.3 10.6-7.3 2.2 0 3.4.2 5 .6V44c-1.4-.6-2.9-.7-4.2-.7-6.7 0-11.1 6.4-11.1 16.6v18.5H444V37.7z"
              />
              <path
                id="Ambassador_svg__Fill-20_00000086664996104979614650000014474276380349638792_"
                className="Ambassador_svg__st12"
                d="M55.5 43.4c0 .5-.1 1-.4 1.4l-.1.2-6.3 9.2-1.1 1.5-.5.8-2.8 4-.5.7-3.2 4.8c0 .1-.1.2-.2.2-.3.3-.6.5-1.1.6H39c-.5 0-.9-.2-1.2-.5l-.1-.1-.4-.4c-2-2.1-5.1-5.4-8.2-8.7-.5-.6-1-1.1-1.5-1.7l-.3-.3c-.2-.2-.3-.5-.5-.7-1.4-1.6-2.8-3-3.8-4.3-.7-.7-1.2-1.3-1.7-1.8-.2-.3-.5-.5-.7-.8-.1-.1-.1-.2-.2-.3-.2-.4-.4-.8-.4-1.2 0-.3.1-.6.2-.9.1-.1.1-.2.2-.4s.2-.4.4-.6c.1-.1.1-.2.2-.3 0-.1.1-.1.1-.2.2-.3.5-.7.7-1 .1-.1.2-.3.3-.4.8-1.1 1.6-2.2 2.5-3.3.7-.9 1.3-1.7 2-2.6.2-.2.3-.5.5-.7 1-1.5 1.9-3.2 2.5-5.2 0-.2.1-.3.1-.5v-.3c.8-2.6 2.3-5.4 3.5-8.1 1.2-2 2.2-3.9 3.2-5.5.3-.4.6-.9.8-1.3.3-.4.5-.8.8-1.2v-.1l.6-.9c.1-.1.2-.3.3-.4 0-.1.1-.1.1-.2.1-.1.2-.3.3-.4.2-.2.3-.4.4-.6l1.2-.3c.1 0 .2-.1.4-.1.1 0 .1-.1.2-.1l2.3 5.9 11.3 25.8.1.1c.3.4.3.8.3 1.2"
              />
              <path
                id="Ambassador_svg__Fill-22_00000078004239302401133300000011957716826325087108_"
                className="Ambassador_svg__st25"
                d="M55.4 76.9c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.2 2-2.1 4.8-2.5l-1.7-13.1.5-.7 2.8-4 .5-.8 2.4 18.5c3 .3 5.3 1.3 5.3 2.6"
              />
              <g
                id="Ambassador_svg__Group-26_00000042729872280144704780000017042416028857510568_"
                transform="translate(36.152)"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000075121852322490812430000005426667643329685949_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.2}
                    width={6.8}
                    height={14.9}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.2}
                  width={6.8}
                  height={14.9}
                  id="Ambassador_svg__mask-18_00000168825487958693112140000012686881635900580492_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000075121852322490812430000005426667643329685949_)">
                    <path
                      id="Ambassador_svg__path-17_00000173882745703171883540000002605218477245156244_"
                      className="Ambassador_svg__st4"
                      d="M6.8-.2H0v14.9h6.8z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-24_00000165955783632007204540000003104666693236680605_"
                  d="M5.5 10.4c-.1 0-.1 0-.2.1-.1 0-.2.1-.4.1l-1.2.3c-.1.2-.3.4-.4.6-.1.2-.2.3-.3.5 0 0 0 .1-.1.1-.1.1-.2.3-.3.4l-.6.9v.1c-.3.4-.5.8-.8 1.2.4-.7.6-1.5.6-2.4l-.2-1.4c-.4-.1-.8-.2-1-.3-.3-.2-.5-.4-.6-.7 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.5.2-2.8c0-.4.4-.8.9-.8.3 0 .6.2.8.4l.1.3L4 3l1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.5.5.8.1.5-.4 1-1.3 1.4"
                  mask="url(#Ambassador_svg__mask-18_00000168825487958693112140000012686881635900580492_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#e8e8e8"
                />
              </g>
              <path
                id="Ambassador_svg__Fill-27_00000081624998643639395360000016507218344455450300_"
                className="Ambassador_svg__st25"
                d="M35.2 76.8c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.1 2-2.1 4.7-2.5l-1.7-13 .6-.8 1.9-2.7c.4.4.8.9 1.2 1.3v.1c.1 0 .1.1.2.1l.3.3c.1.1.2.3.3.5l.1.4L30 74.3c3 .2 5.2 1.3 5.2 2.5"
              />
              <path
                id="Ambassador_svg__Fill-29_00000114047804707953881000000011489328316520963732_"
                className="Ambassador_svg__st25"
                d="M21.5 10.4c-.1 0-.2.1-.2.1-.1 0-.2.1-.4.1v-.1.1l-1.2.3c-.3.4-.7 1-1.1 1.6-.1.1-.1.2-.2.2-.1.1-.2.3-.3.4-.1.1 0 .2-.3.3-.2.5-.6 1-.9 1.5.5-.9.8-2 .8-3.1l-.1-1c-.9-.2-1.6-.5-1.6-1.1 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.3.2-2.7c0-.5.4-.8.9-.8.4 0 .7.2.8.5l1 2.6 1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.4.6.7.1.5-.4 1.1-1.3 1.5"
              />
              <g
                id="Ambassador_svg__Group-33_00000161613068095627465370000016892580237844792987_"
                transform="translate(0 10.496)"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000029740889041170102370000005776582960241456299_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.1}
                    width={27.8}
                    height={56.5}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.1}
                  width={27.8}
                  height={56.5}
                  id="Ambassador_svg__mask-20_00000044883779125620387520000016693740681319336378_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000029740889041170102370000005776582960241456299_)">
                    <path
                      id="Ambassador_svg__path-19_00000140693643393482464960000009815849675797887894_"
                      className="Ambassador_svg__st4"
                      d="M0-.1v56.4h27.8V-.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-31_00000072970496818195056200000010672525460084877489_"
                  d="M27.8 15.4v.4c-.4 2.5-1.2 4.8-2.2 6.6-.2.5-.7 1.3-1.4 2.3-.8 1.1-1.8 2.4-2.8 3.7-.2.2-.3.4-.5.6-.1.1-.1.2-.2.3-1.4 1.7-2.7 3.4-3.5 4.7l-.3.6c-.1.3-.2.7-.2 1.1 0 .6.2 1.1.5 1.6l.3.3c1.1 1.4 3.1 3.6 5.3 6 .3.3.5.6.8.9.8.9 1.7 1.9 2.6 2.8l-2 2.7-.6.8-3.2 4.7-.1.1c-.3.4-.8.7-1.3.7h-.1c-.5 0-.9-.2-1.2-.5l-.1-.1c-3.9-4.1-14-14.8-17-18.5-.4-.5-.6-1.1-.6-1.7 0-.5.1-.9.3-1.3 1.2-2.1 3.7-5.3 5.8-7.9.6-.7 1.1-1.5 1.5-2.1.6-1.1 1.2-2.2 1.6-3.5.1-.4.3-.9.4-1.4.7-2.4 1.9-4.9 3.1-7.4 1.2-2.3 2.5-4.6 3.7-6.5.2-.2.3-.5.4-.7.5-.7.9-1.3 1.1-1.7.2-.1.2-.2.3-.3.1-.2.2-.3.3-.4.1-.1.1-.2.2-.2.4-.6.8-1.1 1.1-1.6L21 .2c0-.1.1-.2.3-.2.1 0 .2-.1.2-.1l.9 2.3L23.5 5l4.1 9.4.2.4v.6"
                  mask="url(#Ambassador_svg__mask-20_00000044883779125620387520000016693740681319336378_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#dc1f26"
                />
              </g>
            </g>
          </g>
          <g
            id="Ambassador_svg__Page-1"
            transform="translate(30 591)"
            className="Ambassador_svg__st1"
          >
            <path
              id="Ambassador_svg__Fill-1_00000157998077039008793940000011654576886619609004_"
              className="Ambassador_svg__st24"
              d="M93.7 30.1L82.6 57.8h22.2L93.7 30.1zm-3.9-7.5h8.4l23.6 55.7H113l-5.7-14.1H80l-5.7 14.1H66l23.8-55.7z"
            />
            <g
              id="Ambassador_svg__Group-34_00000161610909976818330710000012197128455771073434_"
              transform="translate(0 .16)"
              className="Ambassador_svg__st2"
            >
              <path
                id="Ambassador_svg__Fill-2_00000000921708462509766250000010426830486689060012_"
                className="Ambassador_svg__st4"
                d="M124.3 37.5h7v5.9h.2c2.9-4.7 6.9-6.9 12.9-6.9 4.7 0 9.4 2.4 11.6 7.9 2.8-5.8 8.9-7.9 12.6-7.9 10.4 0 14.1 6.7 14.1 15.6v26.1h-7.5V53.9c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V53.9c0-5-1.2-11.3-7.3-11.3-7.7 0-10.7 7.5-10.7 15.1v20.5h-7.5V37.5z"
              />
              <path
                id="Ambassador_svg__Fill-4_00000028294365908536696300000004263542496751992202_"
                className="Ambassador_svg__st4"
                d="M205.9 42.6c-8.1 0-12.1 7.7-12.1 15.3 0 6.8 3.5 15.2 12 15.2 8.1 0 11.4-9 11.3-15.4.1-7.4-3.1-15.1-11.2-15.1zm-19.6-24.3h7.5v24.8h.2c2.3-3.8 6.4-6.5 13.5-6.5 11.8 0 17.6 9.7 17.6 20.6 0 11.2-5.2 22-17.5 22-7.3 0-11.9-3.7-13.9-6.7h-.2v5.8h-7.2v-60z"
              />
              <path
                id="Ambassador_svg__Fill-6_00000085958126096589065520000009938904577694145940_"
                className="Ambassador_svg__st4"
                d="M253.6 58.8c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.2 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.5zm-22.3-18.4c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.4z"
              />
              <path
                id="Ambassador_svg__Fill-8_00000114055348730614016710000009289818372530469565_"
                className="Ambassador_svg__st4"
                d="M265.5 70.2c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6l-.6 6.5c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-10_00000137114827615026561970000012952725850507983241_"
                className="Ambassador_svg__st4"
                d="M293.2 70.2c3 1.9 7.2 2.9 9.3 2.9 3.4 0 7.7-1.4 7.7-5.8 0-7.4-17.6-6.8-17.6-18.2 0-8.5 6.3-12.5 14.4-12.5 3.5 0 6.4.7 9.3 1.6l-.6 6.5c-1.7-1-6.1-2.1-7.9-2.1-3.8 0-7.2 1.6-7.2 5 0 8.3 17.6 5.9 17.6 18.9 0 8.7-6.9 12.7-14.2 12.7-3.8 0-7.7-.4-11.2-2.2l.4-6.8z"
              />
              <path
                id="Ambassador_svg__Fill-12_00000116936174895830755440000002355394715354455183_"
                className="Ambassador_svg__st4"
                d="M347.1 58.8c-1.6 0-3.2-.2-4.8-.2-4.1 0-14.1.6-14.1 7.8 0 4.3 4.1 6.6 7.6 6.6 7.4 0 11.3-4.6 11.3-10.7v-3.5zm-22.2-18.4c3.8-2.2 8.2-3.8 13.4-3.8 11.7 0 16.4 5.7 16.4 16.8v16.8c0 4.6.2 6.8.3 8h-7v-5.3h-.2c-1.8 2.5-5.7 6.2-12.6 6.2-8.8 0-14.9-3.8-14.9-12.7 0-10.2 11.2-13.4 18.9-13.4 3 0 5 0 8 .2 0-7-2.6-10.6-10.1-10.6-4.2 0-8.8 1.6-11.8 4.2l-.4-6.4z"
              />
              <path
                id="Ambassador_svg__Fill-14_00000060753254621218686950000008958203491851564734_"
                className="Ambassador_svg__st4"
                d="M376.7 73.1c8.5 0 12-8.4 12-15.2 0-7.6-3.9-15.3-12.1-15.3-8.1 0-11.3 7.7-11.2 15.1-.1 6.4 3.3 15.4 11.3 15.4zm12.3-.6h-.2c-2 3-6.6 6.7-13.9 6.7-12.3 0-17.5-10.9-17.5-22 0-10.9 5.8-20.6 17.6-20.6 7.1 0 11.2 2.8 13.5 6.5h.2V18.3h7.5v59.9H389v-5.7z"
              />
              <path
                id="Ambassador_svg__Fill-16_00000023963990021059553100000007463075204140420280_"
                className="Ambassador_svg__st4"
                d="M419.7 73.1c8.8 0 12.7-8 12.7-15.3 0-7.7-4.7-15.2-12.7-15.2-8.1 0-12.8 7.5-12.8 15.2 0 7.3 3.9 15.3 12.8 15.3m0-36.6c12.4 0 20.7 8.9 20.7 21.3 0 11.7-8.5 21.3-20.7 21.3-12.3 0-20.8-9.7-20.8-21.3 0-12.3 8.4-21.3 20.8-21.3"
              />
              <path
                id="Ambassador_svg__Fill-18_00000141427124101762975560000012302282097193681567_"
                className="Ambassador_svg__st4"
                d="M444 37.5h7v6.3h.2c2-4.2 6.3-7.3 10.6-7.3 2.2 0 3.4.2 5 .6v6.7c-1.4-.6-2.9-.7-4.2-.7-6.7 0-11.1 6.4-11.1 16.6v18.5H444V37.5z"
              />
              <path
                id="Ambassador_svg__Fill-20_00000006673578143145213820000001163274317127874978_"
                className="Ambassador_svg__st4"
                d="M55.5 43.4c0 .5-.1 1-.4 1.4l-.1.2-6.3 9.2-1.1 1.5-.5.8-2.8 4-.5.7-3.2 4.8c0 .1-.1.2-.2.2-.3.3-.6.5-1.1.6H39c-.5 0-.9-.2-1.2-.5l-.1-.1-.4-.4c-2-2.1-5.1-5.4-8.2-8.7-.5-.6-1-1.1-1.5-1.7l-.3-.3c-.2-.2-.3-.5-.5-.7-1.4-1.6-2.8-3-3.8-4.3-.7-.7-1.2-1.3-1.7-1.8-.2-.3-.5-.5-.7-.8-.1-.1-.1-.2-.2-.3-.2-.4-.4-.8-.4-1.2 0-.3.1-.6.2-.9.1-.1.1-.2.2-.4s.2-.4.4-.6c.1-.1.1-.2.2-.3 0-.1.1-.1.1-.2.2-.3.5-.7.7-1 .1-.1.2-.3.3-.4.8-1.1 1.6-2.2 2.5-3.3.7-.9 1.3-1.7 2-2.6.2-.2.3-.5.5-.7 1-1.5 1.9-3.2 2.5-5.2 0-.2.1-.3.1-.5v-.3c.8-2.6 2.3-5.4 3.5-8.1 1.2-2 2.2-3.9 3.2-5.5.3-.4.6-.9.8-1.3.3-.4.5-.8.8-1.2v-.1l.6-.9c.1-.1.2-.3.3-.4 0-.1.1-.1.1-.2.1-.1.2-.3.3-.4.2-.2.3-.4.4-.6l1.2-.3c.1 0 .2-.1.4-.1.1 0 .1-.1.2-.1l2.3 5.9 11.3 25.8.1.1c.3.4.3.8.3 1.2"
              />
              <path
                id="Ambassador_svg__Fill-22_00000043425472021714142390000007102343686628722087_"
                className="Ambassador_svg__st4"
                d="M55.4 76.9c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.2 2-2.1 4.8-2.5l-1.7-13.1.5-.7 2.8-4 .5-.8 2.4 18.5c3 .3 5.3 1.3 5.3 2.6"
              />
              <g
                id="Ambassador_svg__Group-26_00000081640576383029917570000004929073012413045430_"
                transform="translate(36.152)"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000068646848387077537860000017394888355902280080_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.2}
                    width={6.8}
                    height={14.9}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.2}
                  width={6.8}
                  height={14.9}
                  id="Ambassador_svg__mask-22_00000013185547939597892440000001228072980336503960_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000068646848387077537860000017394888355902280080_)">
                    <path
                      id="Ambassador_svg__path-21_00000145022382905216687910000006876507689945456256_"
                      className="Ambassador_svg__st4"
                      d="M6.8-.2H0v14.9h6.8z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-24_00000023994266261635892850000010444868965961974681_"
                  d="M5.5 10.4c-.1 0-.1 0-.2.1-.1 0-.2.1-.4.1l-1.2.3c-.1.2-.3.4-.4.6-.1.2-.2.3-.3.5 0 0 0 .1-.1.1-.1.1-.2.3-.3.4l-.6.9v.1c-.3.4-.5.8-.8 1.2.4-.7.6-1.5.6-2.4l-.2-1.4c-.4-.1-.8-.2-1-.3-.3-.2-.5-.4-.6-.7 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.5.2-2.8c0-.4.4-.8.9-.8.3 0 .6.2.8.4l.1.3L4 3l1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.5.5.8.1.5-.4 1-1.3 1.4"
                  mask="url(#Ambassador_svg__mask-22_00000013185547939597892440000001228072980336503960_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#fff"
                />
              </g>
              <path
                id="Ambassador_svg__Fill-27_00000016045740136175990590000016862687744800016275_"
                className="Ambassador_svg__st4"
                d="M35.2 76.8c0 1.5-3.3 2.7-7.3 2.7s-7.3-1.2-7.3-2.7c0-1.1 2-2.1 4.7-2.5l-1.7-13 .6-.8 1.9-2.7c.4.4.8.9 1.2 1.3v.1c.1 0 .1.1.2.1l.3.3c.1.1.2.3.3.5l.1.4L30 74.3c3 .2 5.2 1.3 5.2 2.5"
              />
              <path
                id="Ambassador_svg__Fill-29_00000044147512582308998240000016431803083199357355_"
                className="Ambassador_svg__st4"
                d="M21.5 10.4c-.1 0-.2.1-.2.1-.1 0-.2.1-.4.1v-.1.1l-1.2.3c-.3.4-.7 1-1.1 1.6-.1.1-.1.2-.2.2-.1.1-.2.3-.3.4-.1.1 0 .2-.3.3-.2.5-.6 1-.9 1.5.5-.9.8-2 .8-3.1l-.1-1c-.9-.2-1.6-.5-1.6-1.1 0-.2 0-.3.1-.5s.2-.3.4-.5l.1-1.6.2-2.4.2-1.3.2-2.7c0-.5.4-.8.9-.8.4 0 .7.2.8.5l1 2.6 1.5 3.8.5 1.3c.1 0 .2.1.3.1.3.2.5.4.6.7.1.5-.4 1.1-1.3 1.5"
              />
              <g
                id="Ambassador_svg__Group-33_00000119095453736025092090000001891443531740411028_"
                transform="translate(0 10.496)"
              >
                <defs>
                  <filter
                    id="Ambassador_svg__Adobe_OpacityMaskFilter_00000057841675475574949300000008943331872883076748_"
                    filterUnits="userSpaceOnUse"
                    x={0}
                    y={-0.1}
                    width={27.8}
                    height={56.5}
                  >
                    <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                  </filter>
                </defs>
                <mask
                  maskUnits="userSpaceOnUse"
                  x={0}
                  y={-0.1}
                  width={27.8}
                  height={56.5}
                  id="Ambassador_svg__mask-24_00000100364044957686837440000006952780949852808586_"
                >
                  <g filter="url(#Ambassador_svg__Adobe_OpacityMaskFilter_00000057841675475574949300000008943331872883076748_)">
                    <path
                      id="Ambassador_svg__path-23_00000053512783294386949270000005966247507270769034_"
                      className="Ambassador_svg__st4"
                      d="M0-.1v56.4h27.8V-.1z"
                    />
                  </g>
                </mask>
                <path
                  id="Ambassador_svg__Fill-31_00000096053995535368962420000009618587180356498308_"
                  d="M27.8 15.4v.4c-.4 2.5-1.2 4.8-2.2 6.6-.2.5-.7 1.3-1.4 2.3-.8 1.1-1.8 2.4-2.8 3.7-.2.2-.3.4-.5.6-.1.1-.1.2-.2.3-1.4 1.7-2.7 3.4-3.5 4.7l-.3.6c-.1.3-.2.7-.2 1.1 0 .6.2 1.1.5 1.6l.3.3c1.1 1.4 3.1 3.6 5.3 6 .3.3.5.6.8.9.8.9 1.7 1.9 2.6 2.8l-2 2.7-.6.8-3.2 4.7-.1.1c-.3.4-.8.7-1.3.7h-.1c-.5 0-.9-.2-1.2-.5l-.1-.1c-3.9-4.1-14-14.8-17-18.5-.4-.5-.6-1.1-.6-1.7 0-.5.1-.9.3-1.3 1.2-2.1 3.7-5.3 5.8-7.9.6-.7 1.1-1.5 1.5-2.1.6-1.1 1.2-2.2 1.6-3.5.1-.4.3-.9.4-1.4.7-2.4 1.9-4.9 3.1-7.4 1.2-2.3 2.5-4.6 3.7-6.5.2-.2.3-.5.4-.7.5-.7.9-1.3 1.1-1.7.2-.1.2-.2.3-.3.1-.2.2-.3.3-.4.1-.1.1-.2.2-.2.4-.6.8-1.1 1.1-1.6L21 .2c0-.1.1-.2.3-.2.1 0 .2-.1.2-.1l.9 2.3L23.5 5l4.1 9.4.2.4v.6"
                  mask="url(#Ambassador_svg__mask-24_00000100364044957686837440000006952780949852808586_)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAmbassador);
